import { Modal, Form, Input, InputNumber } from 'antd'
import React from 'react'
import PropTypes from 'prop-types'
import toClass from 'recompose/toClass'

const FormItem = Form.Item

function AuthorizationKeyComponent(props) {
  const { form, record, loading, ...rest } = props
  const { getFieldDecorator } = form

  const onChangePurpose = (value) => {
    record.purpose = value
  }

  const onChangeExpiration = (value) => {
    record.expiration = value * 60000
  }

  return (
    <Modal
      centered
      title="Get temporary chatbot authorization key"
      okText="OK"
      okButtonProps={{ loading: props.loading }}
      {...rest}>
      <Form layout="vertical">
        <FormItem label="Purpose (Fill with OS number too, if exists)">
          {getFieldDecorator('Purpose', {
            rules: [
              {
                required: true,
              }
            ]
          })(<Input onChange={(e) => onChangePurpose(e.target.value)} placeholder="Why you need this key?" />)}
        </FormItem>
        <FormItem label="For how many minutes do you need this key? (maximum is 30 minutes)">
          {getFieldDecorator('Expiration', {
            rules: [
              {
                required: true,
              }
            ]
          })(<InputNumber min={0} max={30} defaultValue={15} onChange={onChangeExpiration} />)}
        </FormItem>
      </Form>
    </Modal>
  )
}

export const AuthorizationKeyModal = Form.create({})(toClass(AuthorizationKeyComponent))

AuthorizationKeyComponent.propTypes = {
  form: PropTypes.any,
  loading: PropTypes.bool,
  record: PropTypes.object,
}
